<div class="dialog-popup text-center">
  <mat-spinner class="m-auto" mode="indeterminate"></mat-spinner>
  <h2>{{ data }}</h2>
</div>
